import type { Position } from "./types";

const DEFAULT_PADDING = 16;

export const calculatePosition = (
  rect: DOMRect,
  menuWidth: number,
  viewportWidth: number,
  defaultMenuOpenDirection: "left" | "right"
): Position => {
  const spaceOnRight = viewportWidth - rect.right;
  const spaceOnLeft = rect.left + rect.width;

  // Both sides have enough space - default to right
  if (spaceOnLeft >= menuWidth && spaceOnRight >= menuWidth) {
    return { value: 0, type: defaultMenuOpenDirection };
  }

  // Neither side has enough space - align to left edge with padding
  if (spaceOnLeft < menuWidth && spaceOnRight < menuWidth) {
    if (spaceOnLeft > spaceOnRight) {
      return {
        type: "left",
        value: spaceOnRight * -1 + DEFAULT_PADDING,
      };
    }
    return {
      type: "right",
      value: spaceOnLeft * -1 + DEFAULT_PADDING,
    };
  }

  // Only one side has space - use the side with more space
  return {
    value: 0,
    type: spaceOnRight < spaceOnLeft ? "right" : "left",
  };
};
